import ArcPlcBaseAcreWorkspace from "components/ArcPlc/ArcPlcBaseAcreWorkspace";
import ArcPlcCountyBaseAcreWorkspace from "components/ArcPlc/ArcPlcCountyBaseAcreWorkspace";
import ArcPlcCountyListWorkspace from "components/ArcPlc/ArcPlcCountyListWorkspace";
import ArcPlcCountyWorkspace from "components/ArcPlc/ArcPlcCountyWorkspace";
import FarmPaymentEditWorkspace from "components/ArcPlc/FarmPaymentEditWorkspace";
import FarmPaymentListWorkspace from "components/ArcPlc/FarmPaymentListWorkspace";
import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";
import { Navigate, useLocation } from "react-router";

function ArcPlcFarmPaymentsRedirect() {
  const { pathname, search, hash } = useLocation();
  const target = pathname.replace("/arcplc/farm-payments", "/arcplc/payments");
  return <Navigate to={`${target}${search}${hash}`} replace />;
}

export const arcPlcRoutes = [
  {
    path: "/arcplc/farm-payments",
    element: <ArcPlcFarmPaymentsRedirect />,
  },
  {
    path: "/arcplc/farm-payments/*",
    element: <ArcPlcFarmPaymentsRedirect />,
  },
  {
    path: "/arcplc/payments",
    element: <RouteLayout />,
    children: [
      { index: true, element: <FarmPaymentListWorkspace /> },
      { path: ":farm_payment_id", element: <FarmPaymentEditWorkspace /> },
    ],
    errorElement: <RouteErrorLayout errorTitle="Payments" />,
  },
  {
    path: "/arcplc",
    element: <RouteLayout />,
    children: [{ index: true, element: <ArcPlcCountyListWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="ARC/PLC" />,
  },
  {
    path: "/arcplc/:crop_year/:location_state_name/:location_county_name",
    element: <RouteLayout />,
    children: [{ index: true, element: <ArcPlcCountyWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="ARC/PLC" />,
  },
  {
    path: "/arcplc/:crop_year/:location_state_name/:location_county_name/:commodity_name",
    element: <RouteLayout />,
    children: [{ index: true, element: <ArcPlcCountyBaseAcreWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="ARC/PLC" />,
  },
  {
    path: "/arcplc/:crop_year/:location_state_name/:location_county_name/:commodity_name/:type_name",
    element: <RouteLayout />,
    children: [{ index: true, element: <ArcPlcCountyBaseAcreWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="ARC/PLC" />,
  },
  {
    path: "/arcplc/:crop_year/:location_state_name/:location_county_name/:commodity_name/:type_name/:producer_farm_base_acres_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <ArcPlcBaseAcreWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="ARC/PLC" />,
  },
];
